import {CommonMessages} from '../common.messages';

export const PanelSettingsGroupsEditDetailsMessages = {
    UpdateTradingGroupStatusFailed: {
        key: 'UpdateTradingGroupStatusFailed',
        message: 'Error while processing request to the server. Unable to update group status.'
    },
    GetTradingGroupStatusTriggersFailed: {
        key: 'GetTradingGroupStatusTriggersFailed',
        message: 'Error while processing request to the server. Unable to get the new available group statuses.'
    },
    GetGroupHardBuyingPowerFailed: {
        key: 'GetGroupHardBuyingPowerFailed',
        message: 'Error while processing request to the server. Unable to get the group\'s Total Hard BP.'
    },
    UpdateGroupHardBuyingPowerFailed: {
        key: 'UpdateGroupHardBuyingPowerFailed',
        message: 'Error while processing request to the server. Unable to update the group\'s Total Hard BP.'
    },
    UpdateGroupHardBuyingPowerSucceed: {
        key: 'UpdateGroupHardBuyingPowerSucceed',
        message: 'Total Hard BP updated.'
    },
    GroupHardBuyingPowerUnavailable: {
        key: 'GroupHardBuyingPowerUnavailable',
        message: 'Total Hard BP is not available for this group.'
    },
    ...CommonMessages
};
